import { Box, Typography } from "@mui/material";
import HeaderLogo from "./HeaderLogo";

export default function Header() {
    return (
      <div className="w-full bg-white shadow-md p-4 mb-6 flex justify-between ites-center border-b-4 border-gray-300">
          <Box display="flex" alignItems="center" width="100%" justifyContent="flex-start" gap={2}>
            <HeaderLogo />
            <Typography variant="h5" fontWeight="600">Clinical Viewer</Typography>
        </Box>
      </div>
    );
}